<template>
    <div id="app" @dragover.prevent @drop.prevent>
        <v-container style="max-width:620px;">
            
            <div class="text-center"><v-icon class="white--text">mdi-music-circle</v-icon></div>
            <div class="pt-2 cardTitle white--text synThickFont text-center">Add New Song</div>
            <v-form class="px-3 pt-3 synThinFont" v-on:submit.prevent="submit" ref="form">
                <v-text-field dark prepend-icon="mdi-comma-box" label="Song Title" v-model="title" :rules="titleRules"></v-text-field>
                <v-select dark prepend-icon="mdi-folder"  :items="genreItems" label="Song Genre" v-model="genre" :rules="genreRules" ></v-select>
                
                <!-- <v-file-input 
                    type="file" 
                    :rules="audioRules"
                    placeholder="Upload your song"
                    accept="audio/mp3"
                    name="file-input" 
                    @change="handleFileInput"> 
                </v-file-input> -->
                <div class="file-wrap mt-5 mb-2" :style="{ 'background-color': uploadSongColor }">
                    
                    <div v-if="!file" class="white--text linkHover" @dragleave="fileDragOut" @dragover="fileDragIn" @drop="handleFileDrop"  >
                        <v-icon class="white--text">mdi-attachment</v-icon> Drag and Drop to upload your song <i>(or click to choose)</i>
                        <input type="file" name="file-input" @change="handleFileInput">
                        <!-- <v-file-input 
                            dark
                            type="file" 
                            :rules="audioRules"
                            placeholder="Upload your song"
                            accept="audio/mp3"
                            name="file-input" 
                            @change="handleFileInput"> 
                        </v-file-input> -->
                        <!-- <ul>
                            <li v-for="(file,index) in files" :key="index">
                                {{ file.name }} ({{ file.size }} b) 
                                <v-btn @click="removeFile(index)" title="Remove">X</v-btn>
                            </li>
                            
                        </ul> -->
                    </div>
                    <div v-if="file" class="white--text">
                        {{file.name}}
                    </div>
                </div>
                <!-- <div class="btnFlex">
                    <v-file-input
                        class="songInputCursor"
                        :rules="audioRules"
                        accept="audio/mp3"
                        placeholder="Upload your song"
                        prepend-icon="mdi-music"
                        label="songmp3"
                        @change="onAudioPicked"
                    ></v-file-input>
                </div> -->
                <v-textarea prepend-icon="mdi-pencil" dark label="Comments" v-model="comments"></v-textarea>

                <div class="white--text mb-5 text-center">By uploading this song you agree to the SynthFeed <a class="rl-no-dec  syn_blue_button--text" target="_blank" href="/user-agreement">User Agreement</a>.</div>

                <div class="synThickFont text-center">
                    <!-- <div><v-btn class="error " text @click="dialog = false">Cancel</v-btn></div> -->
                    <div v-if="loading" class="white--text mb-3">{{uploadProgress}}%</div>

                    <div v-if="loading" class="white--text mb-3 uploadProgressBarWrap">
                        <div class="uploadProgressBar" :style="{width:uploadProgressBarWidth}"></div>
                    </div>
                    
                    <div v-if="loading" class="grey--text synThinFont mb-3"><i>Please wait while your song is uploading. This may take a few minutes.</i></div>
                    
                    
                    <div><v-btn class="primary linkHover" text type="submit" :loading="loading">Upload</v-btn></div>
                    
                </div>
                
            </v-form>
        </v-container>
        
        <!-- <div class="file-wrapper">
            <div class="container white--text" @drop="handleFileDrop">
                Add your files here:
                <br>
                <input type="file" name="file-input" multiple="True" @change="handleFileInput">
                <ul>
                    <li v-for="(file,index) in files" :key="index">
                        {{ file.name }} ({{ file.size }} b) 
                        <v-btn @click="removeFile(index)" title="Remove">X</v-btn>
                    </li>
                    
                </ul>
            </div>
        </div> -->

        <Overlay :overlay="overlay" />
    </div>
</template>
<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import fb from '@/fb'
import Overlay from '@/components/layout/Overlay'
const db = fb.db
const storage = fb.storage

export default {
    name: "AddNewSong",
    data() {
        return {
            user:null,
            overlay: true,
            file: null,
            uploadProgress: 0,
            

            title: null,
            genre: null,
            genreItems: ['House / Dance','Bass Music','Hip Hop','Pop', 'Ambient','Experimental','Other'],
            comments: null,
            
            titleRules: [
                v => !!v || 'Title is required',
                v => (v && v.length >= 3) || 'Title must be greater than 3 characters',
                v => (v && v.length <= 30) || 'Title must be less than 30 characters'
            ],
            genreRules: [
                v => !!v || 'Genre is required'
            ],
            audioRules: [
                v => !v || v.size < 20000000 || 'File size should be less than 20 MB!',
                v => !!v || 'Audio is required'
            ],
            
            audioUrl: null,
            audio: null,

            uploadSongColor: "rgba(249, 249, 249,0.1)",

            dialog: false,
            loading: false,
            snackbarText: null,
            timeout: 4000,
            snackbar: false,

            newSongId: null,

            songIcons: ['blue.jpg','green.jpg','orange.jpg','pink.jpg','purple.jpg','yellow.jpg'],
        }
    },
    components: {
        Overlay,
    },
    created() {
        // let user = firebase.auth().currentUser
        firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            // this.user = user
            let ref = db.collection('users')

            

            // ************************* get current user ************************* 
            ref.where('user_id','==',firebase.auth().currentUser.uid).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    this.user = doc.data(),
                    this.user.id = doc.id
                    this.user.email = user.email
                })
            })
            .then(()=>{
            this.overlay = false
            
            })
                
        } else {
            this.user = null
            this.overlay = false
        }
        })
    },
    methods: {
        updateUploadProgress(val){
            this.uploadProgress = val
        },
        submit() {
            if (this.$refs.form.validate() && this.file){
                this.loading = true
                // generate random icon for song
                let randomIcon = this.songIcons[Math.floor(Math.random() * this.songIcons.length)]
                
                // song object
                const song = {
                    title: this.title,
                    genre: this.genre,
                    comments: this.comments,
                    timestamp: Date.now(),
                    user_id: this.user.id,
                    icon: randomIcon,
                    inProgress: true
                }
                let that = this
                let id // will be used to assign song db ID
                let storageAudioUrl // will be used to assign the audio storage path


                // // try old

                // const audioFilename = this.audio.name // grab audio file name
                // const ext = audioFilename.slice(audioFilename.lastIndexOf('.')) //grab audio file extension
                // var uploadTask = storage.ref(`songs/songs/${id}${ext}`).put(this.audio) // return by uploading song to storage
                // // uploadTask.on('state_changed', function progress(snapshot) {
                // //     console.log(snapshot.bytesTransferred,'out of',snapshot.totalBytes); // progress of upload
                // // })

                // // var storageRef = firebase.storage.ref("folderName/file.jpg");
                // // var fileUpload = document.getElementById("fileUpload");
                // // fileUpload.on(‘change’, function(evt) {
                // // var firstFile = evt.target.file[0]; // get the first file uploaded
                // // var uploadTask = storageRef.put(firstFile);
                // // uploadTask.on(‘state_changed’, function progress(snapshot) {
                // //     console.log(snapshot.totalBytesTransferred); // progress of upload
                // // });
                // // });

                // uploadTask
                //     .then((fileData)=>{
                //         storageAudioUrl = fileData.metadata.fullPath // storing song storage path
                //         return storageAudioUrl 
                //     })
                //     .then((storageAudioUrl) =>{
                //         const song = {
                //             title: this.title,
                //             genre: this.genre,
                //             comments: this.comments,
                //             timestamp: Date.now(),
                //             user_id: this.user.id,
                //             icon: randomIcon,
                //             audioPath:storageAudioUrl
                //         }
                //         db.collection('songs').add(song).then((data) => {
                //             id = data.id
                //             this.newSongId =data.id
                //         }).then(()=>{
                //             // console.log('added to db');

                //             this.title = null
                //             this.genre = null
                //             this.soundcloud = null
                            
                //             // this.imageUrl = null
                //             // this.image = null
                //             this.audioUrl= null
                //             this.audio = null

                //             this.comments = null
                //             this.dialog=false
                //             this.loading=false
                            
                //             // this.$emit('projectAdded')

                //             this.snackbarText = "Upload successful."
                //             this.snackbar = true

                //             // this.$router.push({name:'Songs'})
                //             location.href = "/songs";
                //         })
                //     })


                // // try original
                // add song to database
                db.collection('songs').add(song).then((data) => {
                    id = data.id
                    this.newSongId =data.id
                    return id
                })
                // HANDLE AUDIO UPLOAD
                .then(()=>{
                    const audioFilename = this.audio.name // grab audio file name
                    const ext = audioFilename.slice(audioFilename.lastIndexOf('.')) //grab audio file extension
                    var uploadTask = storage.ref(`songs/songs/${id}${ext}`).put(this.audio) // return by uploading song to storage

                    uploadTask.on('state_changed', function progress(snapshot) {
                        // console.log(snapshot.bytesTransferred,'out of',snapshot.totalBytes); // progress of upload
                        // console.log(Math.round(snapshot.bytesTransferred / snapshot.totalBytes));
                        that.updateUploadProgress(Math.round(snapshot.bytesTransferred / snapshot.totalBytes*100))
                    });

                    return uploadTask
                }).then((fileData)=>{
                    storageAudioUrl = fileData.metadata.fullPath // storing song storage path
                    return db.collection('songs').doc(id).update({
                            audioPath:storageAudioUrl,
                            inProgress: false
                        }) // add storage path to DB
                })
                
                // RESET EVERY VARIABLE
                .then(()=>{
                    // console.log('added to db');

                    this.title = null
                    this.genre = null
                    this.soundcloud = null
                    
                    // this.imageUrl = null
                    // this.image = null
                    this.audioUrl= null
                    this.audio = null

                    this.comments = null
                    this.dialog=false
                    this.loading=false
                    
                    // this.$emit('projectAdded')

                    this.snackbarText = "Upload successful."
                    this.snackbar = true

                    // this.$router.push({name:'Songs'})
                    location.href = "/songs";
                })
                .catch((err) => {
                    var newSongRef = db.collection("songs").doc(this.newSongId);

                    newSongRef.get().then(function(doc) {
                        if (doc.exists) {
                            newSongRef.delete().then(function() {
                                console.log("Document successfully deleted!");
                                this.loading=false
                                // location.href = "/songs";

                            }).catch(function(error) {
                                console.error("Error removing document: ", error);
                            });
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    }).catch(function(error) {
                        console.log("Error getting document:", error);
                    });
                    console.log(err);
                })
                
            } else {
                alert('please upload a song')
            }
        },
        // onAudioPicked() {
        //     if(event.target.files){
        //         const audioFiles = event.target.files

        //         let audioFilename = audioFiles[0].name
        //         console.log(audioFilename);
                
        //         // if filename doesn't have a '.' at the end its likely not a correct file so dont proceed
        //         if (audioFilename.lastIndexOf('.') <= 0) {
        //             return alert('please add a valid file.')
        //         }
        //         const audioFileReader = new FileReader()
        //         audioFileReader.addEventListener('load',() => {
        //             this.audioUrl = audioFileReader.result
        //         })
        //         audioFileReader.readAsDataURL(audioFiles[0])
        //         this.audio = audioFiles[0]
        //     }            
            
        // },
        handleFileDrop(e) {
            const audioFile = e.dataTransfer.files[0]
            if (audioFile.type == "audio/mpeg"){
                if (audioFile.size < 20000000) {
                    this.file = audioFile
                    let audioFilename = this.file.name
                    // console.log(audioFilename);
                    // console.log(audioFile.type);
                    // console.log(audioFile.size);

                    // if filename doesn't have a '.' at the end its likely not a correct file so dont proceed
                    // add another one making sure its mp3
                    if (audioFilename.lastIndexOf('.') <= 0) {
                        return alert('please add a valid file.')
                    }

                    const audioFileReader = new FileReader()
                    
                    audioFileReader.addEventListener('load',() => {
                        this.audioUrl = audioFileReader.result
                    })
                    
                    audioFileReader.readAsDataURL(audioFile)
                    
                    this.audio = audioFile
                    this.uploadSongColor="rgba(249, 249, 249,0.1)"
                } else {
                    this.uploadSongColor="rgba(249, 249, 249,0.1)"
                   return alert('The file should not exceed 20 MB')
                }
            } else {
                this.uploadSongColor="rgba(249, 249, 249,0.1)"
                return alert('Please upload an mp3 file')
            }
            

        },
        handleFileInput(e) {

            const audioFile = e.target.files[0]
            if (audioFile.type == "audio/mpeg"){
                if (audioFile.size < 20000000) {
                    this.file = audioFile
                    let audioFilename = this.file.name
                    // console.log(audioFilename);
                    // console.log(audioFile.type);
                    // console.log(audioFile.size);

                    // if filename doesn't have a '.' at the end its likely not a correct file so dont proceed
                    // add another one making sure its mp3
                    if (audioFilename.lastIndexOf('.') <= 0) {
                        return alert('please add a valid file.')
                    }

                    const audioFileReader = new FileReader()
                    
                    audioFileReader.addEventListener('load',() => {
                        this.audioUrl = audioFileReader.result
                    })
                    
                    audioFileReader.readAsDataURL(audioFile)
                    
                    this.audio = audioFile
                    this.uploadSongColor="rgba(249, 249, 249,0.1)"
                } else {
                    this.uploadSongColor="rgba(249, 249, 249,0.1)"
                   return alert('The file should not exceed 20 MB')
                }
            } else {
                this.uploadSongColor="rgba(249, 249, 249,0.1)"
                return alert('Please upload an mp3 file')
            }
        },
        fileDragIn(){
            // alert("oof")
            // alert("color")
            this.uploadSongColor="rgba(249, 249, 249,0.5)"
        },
        fileDragOut(){
            this.uploadSongColor="rgba(249, 249, 249,0.1)"
        },
        removeFile(fileKey){
           this.files.splice(fileKey, 1)
        }
    },
    computed: {
        uploadProgressBarWidth: function () {
            // return this.progress*this.sliderTopWidth + 'px'
            return this.uploadProgress+'%'
        },
    }
}
</script>

<style>
.uploadProgressBarWrap{
    margin-left:30px;
    height: 10px;
    border-radius:5px;
    background-color: white;
}
.uploadProgressBar{
    height: 10px;
    border-radius:5px;
    background-color: #087FFF;
}

.file-wrap {
    text-align: center;
    width: 95%;
    margin-left:30px;
    height: 200px;
    line-height: 200px;
    vertical-align: middle !important;
    /* display: table-cell; */
    position: relative;
    overflow: hidden;
    border: 1px solid white;
    border-radius: 5px;
     /* background: gray;  */
     /*and other things to make it pretty */
}
.file-wrap input {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer !important;
    opacity: 0;
    filter: alpha(opacity=0);
    font-size: 0;
    height: 200px;
    width: 100%;
    /* background: red; */
}
</style>